import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import Diversity3RoundedIcon from '@mui/icons-material/Diversity3Rounded';
import AutoStoriesRoundedIcon from '@mui/icons-material/AutoStoriesRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';

export const devoteeSections = [
  {
    key: 'profile',
    label: 'Personal profile',
    description: 'Update personal details, contacts, and addresses so mentors always have the right information.',
    icon: PersonRoundedIcon,
  },
  {
    key: 'family',
    label: 'Family & household',
    description: 'Link relatives, confirm relationships, and manage safeguarding preferences.',
    icon: Diversity3RoundedIcon,
  },
  {
    key: 'batches',
    label: 'My Batches',
    description: 'View your enrolled course batches and track your learning progress.',
    icon: GroupsRoundedIcon,
  },
  {
    key: 'books',
    label: 'Book Reading',
    description: 'Track the spiritual books you are reading with start and finish dates.',
    icon: MenuBookRoundedIcon,
  },
  {
    key: 'devotional',
    label: 'Sādhanā',
    description: 'Log your sādhanā entries and weekly card.',
    icon: AutoStoriesRoundedIcon,
  },
  {
    key: 'services',
    label: 'Services',
    description: 'View services assigned to you by mentors and track your progress.',
    icon: AssignmentRoundedIcon,
  },
] as const;

export type DevoteeSectionKey = (typeof devoteeSections)[number]['key'];

export const defaultDevoteeSectionKey: DevoteeSectionKey = 'profile';

export const isDevoteeSectionKey = (value: string | undefined): value is DevoteeSectionKey =>
  Boolean(value) && devoteeSections.some((section) => section.key === value);
